export default $axios => resource => ({
  fetchSchedules(params) {
    return $axios.get(`${resource}/jobschedules?jobType=${params}`)
  },
})
